import { BaseInjectorService } from 'src/app/base/base-service.injecter';
import { ModalHelpComponent } from './../modal-help/modal-help.component';
import {
  ModalController,
  MenuController,
  AlertController,
} from '@ionic/angular';
import { Component, OnInit, inject,Input } from '@angular/core';
import { PopoverHelpComponent } from '../popover-help/popover-help.component';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
// import { AngularFireRemoteConfig } from '@angular/fire/remote-config';
// import { RemoteConfig } from "@angular/fire/remote-config";

@Component({
    selector: 'lh-header-menu',
    templateUrl: './header-menu.component.html',
    styleUrls: ['./header-menu.component.scss'],
    standalone: false
})
export class HeaderMenuComponent extends BaseInjectorService
  implements OnInit {
  faqURL = "";
  @Input() menuData: any;
  // private remoteConfig=inject(RemoteConfig);
  
  private readonly logoutUrl = environment.base_url.hanzapp.url+'auth/rest/loginApp/logout';
  private readonly apiGatewayId = environment.API_GATEWAY_ID;

  constructor(
    public modalCtrl: ModalController,
    private menuCtrl: MenuController,
    public alertCtrl: AlertController,
    public auth:AuthService
    // private remoteConfig: AngularFireRemoteConfig
  ) {
    super();
  }

  ngOnInit() {
    this.menuCtrl.enable(true);
    this.auth.getUserInfo().then((userData) => {
      this.menuData.user = userData ? userData['USER_NAME'] : 'User';
    });
  }

  checkForValidUser() {
    if (this.menuData.user === 'User' || this.menuData.user === undefined || this.menuData.user === '') {
      this.auth.getUserInfo().then((userData) => {
        this.menuData.user = userData ? userData['USER_NAME'] : 'User';
      });
    }
  }
  async logout() {
    await this.logoutAPICallForDiscardAccessToken();
    await this.auth.clearSession();
    await this.eventSevice.emitUserLogout(true);
    await this.router.navigate(['/login'], { replaceUrl: true });
  }

  async openHelpPopover() {
    // await this.remoteConfig.strings.faq_link.subscribe(async url => {
    //   const link = await url;
    //   this.faqURL = link || "";
    // });
    const popover = await this.presentPopover(PopoverHelpComponent, event);
    popover.onDidDismiss().then((action) => {
      if (action && action.data) {
        if (action.data === 'faq') {
          this.openFAQFile();
        } else if (action.data === 'contactus') {
          this.opneContactUsModal();
        }
      }
    });
  }

  openFAQFile() {
    if (this.faqURL) {
      window.open(this.faqURL);
    }
  }

  async opneContactUsModal() {
    const modal = await this.modalCtrl.create({
      component: ModalHelpComponent,
      cssClass:'help-modal',
       backdropDismiss: false
    });
    return await modal.present();
  }
  async logoutAlert() {
    const alert = await this.alertCtrl.create({
      header: 'Confirm logout',
      message: 'Do you really want to logout?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => { }
        },
        {
          text: 'Yes',
          handler: () => {
            this.logout();
          }
        }
      ]
    });
    await alert.present();
  }

  toggleMenu() {
    this.menuCtrl.toggle();
  }

   async logoutAPICallForDiscardAccessToken(): Promise<void> {
    try {
      const userData:any = await this.auth.getUserInfo();
      if (!userData.TOKEN) {
        console.warn('Logout skipped: No token found');
        return;
      }
      const headers = new HttpHeaders({
        'Authorization': userData.TOKEN,
        'x-apigw-api-id': this.apiGatewayId
      });
      this.auth.logout(this.logoutUrl,headers).subscribe((response: any) => {
        console.log('Logged out successfully'+response);
      }, (error: any) => {
        console.error('Error during logout', error);
      })
      console.log('Logout API called successfully, token discarded.');
    } catch (error) {
      console.error('Logout API call failed', error);
    }
  }

}
